<template>
  <div>
    <div class="qy-header-wrapper">
      <div class="qy-header">企业</div>

      <div class="tab box">
        <div class="tab1 tab-item" @click="toList">列表</div>

        <div class="tab2 tab-item" @click="toMap">地图</div>

        <div class="tab3 tab-item select" @click="toTotal">统计</div>
      </div>
    </div>

    <div style="position: relative;margin-bottom: 20px">
      <!--:style="{height:Height*0.882+'px'}"-->

      <div class="map-wrapper" id="container"></div>

      <!--右上角筛选列表-->

      <div class="btn-wrapper box">
        <div
          v-if="isJiedao==1"
          class="select-btn select-service-btn"
          :style="{color:showShequ?'#ff7b44':''}"
          @click="showShequList"
        >
          <div class="box select-btn-text">
            组织区域
            <div class="iconfont xia icon-xiala" :class="{'changexia':showShequ}"></div>
          </div>

          <ul v-if="showShequ" class="service-list">
            <li
              v-for="(item,index) in childShequ"
              :key="index"
              class="box"
              @click.stop="selectShequ(item,index)"
            >
              <i v-if="item.isSelect" class="iconfont icon-xuanzhong1 xuan"></i>

              <i v-else class="iconfont icon-xuanzhongkuang weixuan"></i>

              <div :style="{color:item.isSelect?'#ff7b44':''}">{{item.name}}</div>
            </li>
          </ul>
        </div>

        <div
          class="select-btn select-service-btn"
          :style="{color:showService?'#ff7b44':''}"
          @click="showServiceList"
        >
          <div class="box select-btn-text">
            服务类型
            <div class="iconfont xia icon-xiala" :class="{'changexia':showService}"></div>
          </div>

          <ul v-if="showService" class="service-list">
            <li
              class="service-li box"
              v-for="(item,index) in serviceList"
              :key="index"
              @click.stop="showChild(item)"
            >
              <i
                v-if="item.isSelect"
                class="iconfont icon-duoxuan1 xuan"
                @click.stop="selectService(item,index)"
              ></i>

              <i
                v-else
                class="iconfont icon-duoxuankuang1 weixuan"
                @click.stop="selectService(item,index)"
              ></i>

              <div :style="{color:item.isSelect?'#ff7b44':''}" class="service-name">{{item.name}}</div>

              <ul v-if="item.children.length>0 && item.childShow" class="service-child">
                <li
                  v-for="(_item,_index) in item.children"
                  :key="_index"
                  class="box"
                  @click.stop="showChild(_item)"
                >
                  <i
                    v-if="_item.isSelect"
                    class="iconfont icon-duoxuan1 xuan"
                    @click.stop="selectService(_item,index)"
                  ></i>

                  <i
                    v-else
                    class="iconfont icon-duoxuankuang1 weixuan"
                    @click.stop="selectService(_item,index)"
                  ></i>

                  <div :style="{color:_item.isSelect?'#ff7b44':''}">{{_item.name}}</div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>

      <Card class="echart-wrapper echart1-wrapper" :padding="padding">
        <div class="echart-head box">
          <div class="box box_center">
            <i class="iconfont icon-shuju echart-head-icon"></i>

            <div>各社区八大类对比的情况</div>
          </div>

          <Button
            type="primary"
            @click="showBigEc1 = true,showBigEc2=false ,showBigEc3 = false"
            class="ec-btn"
            size="small"
          >放大
          </Button>
        </div>

        <div id="echart1"></div>
      </Card>

      <Card class="echart-wrapper bigEchart-wrapper" :padding="padding" v-show="showBigEc1">
        <div class="echart-head box">
          <div class="box box_center">
            <i class="iconfont icon-shuju echart-head-icon"></i>

            <div>各社区八大类对比的情况</div>
          </div>

          <Icon type="md-close" size="30" color="#ccc" @click="showBigEc1 = false"/>
        </div>

        <div id="bigEchart1" :style="{height: Height*0.781+'px',width:Width*0.6197+'px'}"></div>
      </Card>

      <Card class="echart-wrapper echart2-wrapper" :padding="padding">
        <div class="echart-head box">
          <div class="box box_center">
            <i class="iconfont icon-shuju echart-head-icon"></i>

            <div>各社区规划与实际商铺数量对比</div>
          </div>

          <Button
            type="primary"
            @click="showBigEc2 = true , showBigEc1=false ,showBigEc3 = false"
            class="ec-btn"
            size="small"
          >放大
          </Button>
        </div>

        <div id="echart2"></div>
      </Card>

      <Card class="echart-wrapper bigEchart-wrapper" :padding="padding" v-show="showBigEc2">
        <div class="echart-head box">
          <div class="box box_center">
            <i class="iconfont icon-shuju echart-head-icon"></i>

            <div>各社区规划与实际商铺数量对比</div>
          </div>

          <Icon type="md-close" size="30" color="#ccc" @click="showBigEc2 = false"/>
        </div>

        <div id="bigEchart2" :style="{height: Height*0.781+'px',width:Width*0.6197+'px'}"></div>
      </Card>

      <Card class="echart-wrapper echart3-wrapper" :padding="padding">
        <div class="echart-head box">
          <div class="box box_center">
            <i class="iconfont icon-paiming echart-head-icon"></i>

            <div>统计商铺信誉（评价排名）情况</div>
          </div>

          <Button
            type="primary"
            @click="showBigEc3 = true , showBigEc1=false ,showBigEc2=false"
            class="ec-btn"
            size="small"
          >放大
          </Button>
        </div>

        <div id="echart3"></div>
      </Card>

      <Card class="echart-wrapper bigEchart-wrapper" :padding="padding" v-show="showBigEc3">
        <div class="echart-head box">
          <div class="box box_center">
            <i class="iconfont icon-paiming echart-head-icon"></i>

            <div>统计商铺信誉（评价排名）情况</div>
          </div>

          <Icon type="md-close" size="30" color="#ccc" @click="showBigEc3 = false"/>
        </div>

        <div id="bigEchart3" :style="{height: Height*0.781+'px',width:Width*0.6197+'px'}"></div>
      </Card>
    </div>
  </div>
</template>


<script>
  var that,
    map,
    geocoder,
    heatmap,
    markerList = [],
    BigEc1,
    BigEc2,
    BigEc3,
    communityId = [],
    serviceId = [];

  // 引入 ECharts 主模块

  var echarts = require("echarts/lib/echarts");

  // // 引入柱状图

  require("echarts/lib/chart/bar");

  // 引入提示框和标题组件

  require("echarts/lib/component/tooltip");

  require("echarts/lib/component/title");

  require("echarts/lib/component/grid");

  require("echarts/lib/component/legendScroll");

  require("echarts/lib/component/dataZoom");

  import ditu from "../../assets/images/select.png";

  export default {
    components: {},

    data() {
      return {
        Height: window.document.body.offsetHeight - 60,

        Width: window.document.body.offsetWidth,

        serviceList: [],

        showService: false, //显示选择服务list

        echarts1: "", //各社区8大类对比情况 柱状图

        echarts2: "", //各社区规划与实际商铺数量对比 柱状图

        echarts3: "", //统计商户信誉（评价排名）情况 柱状图,

        heatMap: "",

        page: 1,

        rows: 100,

        rule: {
          typeIdList: [], //企业类型ID集合

          serviceIdList: [], //服务类型ID集合

          companyName: "", //查询企业名称

          address: "", //查询企业地址
          communityIdList: [this.$store.state.streetorcommunityid], //所要查询的行政区域ID
          checkInfo: {status: 1}
        }, // 过滤器筛选类型

        zuobiaoList: [],

        qiyeTotal: [],

        padding: 0,

        showBigEc1: false,

        showBigEc2: false,

        showBigEc3: false,

        showShequ: false,

        childShequ: []
      };
    },

    computed: {
      isJiedao() {
        return this.$store.state.isJiedao;
      }
    },

    methods: {
      toList() {
        this.$router.push({name: "userEnterprise"});
      },

      toMap() {
        this.$router.push({name: "qiyeMap"});
      },

      toTotal() {
        return;
      },

      handleResize(event) {
        this.Width = document.documentElement.clientWidth;

        this.Height = document.documentElement.clientHeight - 60;
      },

      initMap() {
        map = new AMap.Map("container", {
          zoom: 15, //设置地图显示的缩放级别

          center: [116.396923, 39.918203], //设置地图中心点坐标

          // layers: [new AMap.TileLayer.Satellite()],  //设置图层,可设置成包含一个或多个图层的数组

          mapStyle: "amap://styles/normal", //设置地图的显示样式

          viewMode: "2D", //设置地图模式

          lang: "zh_cn" //设置地图语言类型
        });

        //逆地理编码

        geocoder = new AMap.Geocoder({
          // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode

          city: "010"
        });

        var center = "";

        var didian = "";

        map.plugin("AMap.Geolocation", function () {
          var geolocation = new AMap.Geolocation({
            // 是否使用高精度定位，默认：true

            enableHighAccuracy: true,

            // 设置定位超时时间，默认：无穷大

            timeout: 10000,

            // 定位按钮的停靠位置的偏移量，默认：Pixel(10, 20)

            // buttonOffset: new AMap.Pixel(10, 20),

            //  定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false

            zoomToAccuracy: true,

            //  定位按钮的排放位置,  RB表示右下

            buttonPosition: "RB"
          });

          geolocation.getCurrentPosition((status, result) => {
            if (status == "complete") {
              center = [result.position.lng, result.position.lat];

              map.setCenter(center);

              geocoder.getAddress(center, function (status, result) {
                if (status === "complete" && result.info === "OK") {
                  // result为对应的地理位置详细信息

                  didian = result.regeocode.formattedAddress;

                  var text = new AMap.Text({
                    text: "我在 " + didian + " 这",

                    anchor: "center", // 设置文本标记锚点

                    style: {
                      padding: "5px 10px",

                      "border-radius": "4px",

                      "background-color": "white",

                      // 'width': '15rem',

                      // 'border-width': 0,

                      "box-shadow": "0px 2px 10px 1px #9f9e9a",

                      "text-align": "center",

                      "font-size": "15px",

                      color: "#333"
                    },

                    offset: new AMap.Pixel(0, -40),

                    position: center
                  });

                  text.setMap(map);
                }
              });

              var circleMarker = new AMap.CircleMarker({
                center: center,

                radius: 10, //3D视图下，CircleMarker半径不要超过64px

                strokeColor: "#4685e6",

                strokeOpacity: 1,

                fillColor: "#4685e6",

                fillOpacity: 1,

                bubble: true
              });

              circleMarker.setMap(map);
            }
          });

          AMap.event.addListener(geolocation, "complete", onComplete);

          AMap.event.addListener(geolocation, "error", onError);

          function onComplete(data) {
            // data是具体的定位信息
          }

          function onError(data) {
            // 定位出错
          }
        });

        map.on("complete", function () {
          // 地图图块加载完成后触发
        });

        map.on("click", function (ev) {
          // 触发事件的对象

          console.log(ev);

          var target = ev.target;

          // 触发事件的地理坐标，AMap.LngLat 类型

          var lnglat = ev.lnglat;

          // 触发事件的像素坐标，AMap.Pixel 类型

          var pixel = ev.pixel;

          // 触发事件类型

          var type = ev.type;
        });
      },

      getEchartsData() {
        var getEchrts1 = this.getEchrts1();

        var getEchrts2 = this.getEchrts2();

        var getEchrts3 = this.getEchrts3();

        Promise.all([getEchrts1, getEchrts2, getEchrts3])
          .then(res => {
            that.echarts1 = res[0].rows[0];

            that.echarts2 = res[1].rows[0];

            that.echarts3 = res[2].rows[0];

            that.initEcharts();

            that.initBigEc1();

            that.initBigEc2();

            that.initBigEc3();
          })
          .catch(e => {
            console.log(e);
          });
      },


      getEchrts1() {
        return new Promise((resolve, reject) => {
          var url = that.urlobj.getEcharts1;

          that
            .$get(url)
            .then(res => {
              if (res.isSucceed) {
                resolve(res);
              }
            })
            .catch(e => {
              reject(e);
            });
        });
      },

      getEchrts2() {
        return new Promise((resolve, reject) => {
          var url = that.urlobj.getEcharts2;

          that
            .$get(url)
            .then(res => {
              if (res.isSucceed) {
                resolve(res);
              }
            })
            .catch(e => {
              reject(e);
            });
        });
      },

      getEchrts3() {
        return new Promise((resolve, reject) => {
          var date = this.$util.FormatDate(new Date().valueOf(), "yyyy-MM-dd");

          var url = that.urlobj.getEcharts3;

          that
            .$get(url, {
              orderSeq: "DESC",

              pageNum: 0,

              pageSize: 0,

              beginDate: "2018-01-01",

              endDate: date
            })
            .then(res => {
              if (res.isSucceed) {
                resolve(res);
              }
            })
            .catch(e => {
              reject(e);
            });
        });
      },

      initEcharts() {
        //各社区八大类对比情况

        var echart1 = echarts.init(document.getElementById("echart1"));

        // var isJiedao = sessionStorage.isJiedao

        var data1 = that.echarts1;

        var data2 = that.echarts2;

        var data3 = that.echarts3;

        var option1 = {
          tooltip: {
            trigger: "item",

            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效

              type: "shadow" // 默认为直线，可选为：'line' | 'shadow' | 'none' | 'cross'
            }
          },

          legend: {
            // http://bkccshequ.img-cn-beijing.aliyuncs.com/mst/2019/10/8/4614819599664128.png
            type:'scroll',
            pageIcons:{
              horizontal:['image://http://bkccshequ.img-cn-beijing.aliyuncs.com/mst/2019/10/8/4614839464494080.png','image://http://bkccshequ.img-cn-beijing.aliyuncs.com/mst/2019/10/8/4614840012669952.png']
            },
            itemWidth: 12,

            itemHeight: 10,

            data: data1.legend
          },

          grid: {
            top: "15%",

            left: "0",

            right: "0",

            bottom: "3%",

            containLabel: true
          },

          xAxis: [
            {
              type: "category",

              data: data1.xaxis,

              axisTick: {
                show: false
              },

              axisLine: {
                lineStyle: {
                  color: "#999"
                }
              },

              axisLabel: {
                color: "#999"
              }
            }
          ],

          yAxis: [
            {
              type: "value",

              splitLine: {
                show: false
              },

              axisTick: {
                show: false
              },

              axisLine: {
                lineStyle: {
                  color: "#999"
                }
              },

              axisLabel: {
                color: "#999"
              },

              minInterval: 1
            }
          ],

          series: data1.series.map(item => {
            return {
              name: item.name,

              type: "bar",

              barGap: "100%",

              data: item.data,

              barWidth: 15,

              itemStyle: {
                color: item.color,

                barBorderRadius: 3
              }
            };
          })
        };

        if (that.isJiedao == 1) {
          option1.series.forEach(item => {
            item.stack = "八大类";
          });
        }

        if (that.isJiedao == 1 && data1.xaxis.length > 15) {
          option1.dataZoom = {
            type: "inside",

            // xAxisIndex: [0],

            startValue: 0,

            endValue: 5
          };
        }

        echart1.setOption(option1);

        //各社区规划与实际商铺数量对比

        var echart2 = echarts.init(document.getElementById("echart2"));

        var option2 = {
          tooltip: {
            trigger: "item",

            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效

              type: "shadow" // 默认为直线，可选为：'line' | 'shadow' | 'none' | 'cross'
            }
          },

          legend: {
            itemWidth: 12,

            itemHeight: 10,

            data: data2.legend
          },

          grid: {
            top: "15%",

            left: "0",

            right: "0",

            bottom: "3%",

            containLabel: true
          },

          xAxis: [
            {
              type: "category",

              data: data2.xaxis,

              axisLine: {
                lineStyle: {
                  color: "#999"
                }
              },

              axisTick: {
                show: false
              },

              axisLabel: {
                color: "#999"
              }
            }
          ],

          yAxis: [
            {
              type: "value",

              splitLine: {
                show: false
              },

              axisLine: {
                lineStyle: {
                  color: "#999"
                }
              },

              axisTick: {
                show: false
              },

              axisLabel: {
                color: "#999"
              },

              minInterval: 1
            }
          ],

          series: data2.series.map(item => {
            return {
              name: item.name,

              type: "bar",

              barGap: that.isJiedao == 1 ? "100%" : "60%",

              data: item.data,

              barWidth: that.isJiedao == 1 ? 6 : 50,

              itemStyle: {
                color: item.name == "规划" ? "#fbb927" : "#b1d87b",

                barBorderRadius: 5
              }
            };
          })
        };

        if (that.isJiedao == 1 && data2.xaxis.length > 5) {
          option2.dataZoom = {
            type: "inside",

            // xAxisIndex: [0],

            startValue: 0,

            endValue: 5
          };
        }

        echart2.setOption(option2);

        //统计商铺信誉（评价排名）情况

        var echart3 = echarts.init(document.getElementById("echart3"));

        var option3 = {
          grid: {
            top: "3%",

            left: "3%",

            right: "40",

            bottom: "3%",

            containLabel: true
          },

          xAxis: [
            {
              show: false,

              type: "value",

              splitLine: {
                show: false
              },

              max: 5
            }
          ],

          yAxis: [
            {
              type: "category",

              axisLine: {
                show: false
              },

              axisTick: {
                show: false
              },

              data: data3.yaxis.slice(-5),

              axisLabel: {
                //坐标轴刻度标签的相关设置。

                interval: 0,

                formatter: function (params) {
                  var newParamsName = ""; // 最终拼接成的字符串

                  if (params.length > 10) {
                    params = params.slice(0, 7) + "···";
                  }

                  var paramsNameNumber = params.length; // 实际标签的个数

                  var provideNumber = 5; // 每行能显示的字的个数

                  var rowNumber = Math.ceil(paramsNameNumber / provideNumber);

                  /**

<<<<<<< HEAD
<<<<<<< HEAD
=======
                var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
=======
                   <<<<<<< HEAD
                   =======
                   var rowNumber = Math.ceil(paramsNameNumber / provideNumber);
>>>>>>> f1542f1ef66ba50eb06015932af679e34769205d

                   /**

<<<<<<< HEAD
>>>>>>> dev
=======
                   >>>>>>> dev
>>>>>>> f1542f1ef66ba50eb06015932af679e34769205d

                   * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签


                   */

                  // 条件等同于rowNumber>1

                  if (paramsNameNumber > provideNumber) {
                    /** 循环每一行,p表示行 */

                    for (var p = 0; p < rowNumber; p++) {
                      var tempStr = ""; // 表示每一次截取的字符串

                      var start = p * provideNumber; // 开始截取的位置

                      var end = start + provideNumber; // 结束截取的位置

                      // 此处特殊处理最后一行的索引值

                      if (p == rowNumber - 1) {
                        // 最后一次不换行

                        tempStr = params.substring(start, paramsNameNumber);
                      } else {
                        // 每一次拼接字符串并换行

                        tempStr = params.substring(start, end) + "\n";
                      }

                      newParamsName += tempStr; // 最终拼成的字符串
                    }
                  } else {
                    // 将旧标签的值赋给新标签

                    newParamsName = params;
                  }

                  //将最终的字符串返回

                  return newParamsName;
                }
              }
            }
          ],

          // dataZoom:{

          //   type:'inside',

          //   yAxisIndex: [0]

          // },

          series: [
            {
              type: "bar",

              data: data3.series[0].data.slice(-5),

              z: 3,

              barWidth: 8,

              barGap: "-100%",

              itemStyle: {
                color: "#ff7c44",

                barBorderRadius: 5
              }
            },

            {
              type: "bar",

              silent: true,

              barWidth: 8,

              itemStyle: {
                color: "#eee",

                barBorderRadius: 5
              },

              label: {
                show: true,

                position: "right",

                distance: 10,

                formatter: function (params) {
                  console.log(params);

                  for (var i = 0; i < option3.series[0].data.length; i++) {
                    if (i == params.dataIndex) {
                      return option3.series[0].data[i];
                    }
                  }
                },

                color: "#ff7c44",

                fontSize: 16
              },

              data: new Array(5).fill(5)
            }
          ]
        };

        echart3.setOption(option3);
      },

      initBigEc1() {
        BigEc1 = echarts.init(document.getElementById("bigEchart1"));

        var data1 = that.echarts1;

        var option1 = {
          tooltip: {
            trigger: "item",

            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效

              type: "shadow" // 默认为直线，可选为：'line' | 'shadow' | 'none' | 'cross'
            }
          },

          legend: {
            data: data1.legend,
            left: 0,

          },

          grid: {
            top: "7%",

            left: "0",

            right: "0",

            bottom: "7%",

            containLabel: true
          },

          xAxis: [
            {
              type: "category",

              data: data1.xaxis,

              axisTick: {
                show: false
              },

              axisLine: {
                lineStyle: {
                  color: "#999"
                }
              },

              axisLabel: {
                interval: 0,

                color: "#999",

                rotate: 0
              }
            }
          ],

          yAxis: [
            {
              type: "value",

              splitLine: {
                show: false
              },

              axisLine: {
                lineStyle: {
                  color: "#999"
                }
              },

              axisTick: {
                show: false
              },

              axisLabel: {
                color: "#999"
              },

              minInterval: 1
            }
          ],

          series: data1.series.map(item => {
            return {
              name: item.name,

              type: "bar",

              barGap: "100%",

              data: item.data,

              barWidth: 20,

              itemStyle: {
                color: item.color,

                barBorderRadius: 3,

                borderWidth: 1,

                borderColor: "#fff"
              }
            };
          })
        };

        if (that.isJiedao == 1) {
          option1.series.forEach(item => {
            item.stack = "八大类";
          });

          if (data1.xaxis.length > 10) {
            option1.xAxis[0].axisLabel.rotate = 30;

            option1.dataZoom = {
              type: "slider",

              startValue: 0,

              endValue: 10
            };
          }
        }

        console.log(option1);

        BigEc1.setOption(option1);
      },

      initBigEc2() {
        var data2 = that.echarts2;

        BigEc2 = echarts.init(document.getElementById("bigEchart2"));

        var option2 = {
          tooltip: {
            trigger: "item",

            axisPointer: {
              // 坐标轴指示器，坐标轴触发有效

              type: "shadow" // 默认为直线，可选为：'line' | 'shadow' | 'none' | 'cross'
            }
          },

          legend: {
            itemWidth: 12,

            itemHeight: 10,

            data: data2.legend
          },

          grid: {
            top: "7%",

            left: "0",

            right: "0",

            bottom: "7%",

            containLabel: true
          },

          xAxis: [
            {
              type: "category",

              data: data2.xaxis,

              axisTick: {
                show: false
              },

              axisLine: {
                lineStyle: {
                  color: "#999"
                }
              },

              axisLabel: {
                interval: 0,

                color: "#999"

                // rotate:30
              }
            }
          ],

          yAxis: [
            {
              type: "value",

              splitLine: {
                show: false
              },

              axisTick: {
                show: false
              },

              axisLine: {
                lineStyle: {
                  color: "#999"
                }
              },

              minInterval: 1
            }
          ],

          series: data2.series.map(item => {
            return {
              name: item.name,

              type: "bar",

              barGap: that.isJiedao == 1 ? "100%" : "60%",

              data: item.data,

              barWidth: that.isJiedao == 1 ? 15 : 50,

              itemStyle: {
                color: item.name == "规划" ? "#fbb927" : "#b1d87b",

                barBorderRadius: 5
              }
            };
          })
        };

        if (that.isJiedao == 1) {
          if (data2.xaxis.length > 10) {
            option2.xAxis[0].axisLabel.rotate = 30;

            option2.dataZoom = {
              type: "slider",

              startValue: 0,

              endValue: 10
            };
          }
        }

        BigEc2.setOption(option2);
      },

      initBigEc3() {
        BigEc3 = echarts.init(document.getElementById("bigEchart3"));

        var data3 = that.echarts3;

        var option3 = {
          grid: {
            top: "3%",

            left: "3%",

            right: "8%",

            bottom: "3%",

            containLabel: true
          },

          xAxis: [
            {
              show: false,

              type: "value",

              splitLine: {
                show: false
              },

              max: 5
            }
          ],

          yAxis: [
            {
              type: "category",

              axisLine: {
                show: false
              },

              axisTick: {
                show: false
              },

              data: data3.yaxis,

              axisLabel: {
                //坐标轴刻度标签的相关设置。

                interval: 0,

                formatter: function (params) {
                  var newParamsName = ""; // 最终拼接成的字符串

                  var paramsNameNumber = params.length; // 实际标签的个数

                  var provideNumber = 10; // 每行能显示的字的个数

                  var rowNumber = Math.ceil(paramsNameNumber / provideNumber);

                  /**

                   * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签


                   */

                  // 条件等同于rowNumber>1

                  if (paramsNameNumber > provideNumber) {
                    /** 循环每一行,p表示行 */

                    for (var p = 0; p < rowNumber; p++) {
                      var tempStr = ""; // 表示每一次截取的字符串

                      var start = p * provideNumber; // 开始截取的位置

                      var end = start + provideNumber; // 结束截取的位置

                      // 此处特殊处理最后一行的索引值

                      if (p == rowNumber - 1) {
                        // 最后一次不换行

                        tempStr = params.substring(start, paramsNameNumber);
                      } else {
                        // 每一次拼接字符串并换行

                        tempStr = params.substring(start, end) + "\n";
                      }

                      newParamsName += tempStr; // 最终拼成的字符串
                    }
                  } else {
                    // 将旧标签的值赋给新标签

                    newParamsName = params;
                  }

                  //将最终的字符串返回

                  return newParamsName;
                }
              }
            }
          ],

          dataZoom: {
            type: "slider",

            startValue: 0,

            endValue: 10,

            orient: "vertical"
          },

          series: [
            {
              type: "bar",

              data: data3.series[0].data,

              z: 3,

              barWidth: 15,

              barGap: "-100%",

              itemStyle: {
                color: "#ff7c44",

                barBorderRadius: 5
              }
            },

            {
              type: "bar",

              silent: true,

              barWidth: 15,

              itemStyle: {
                color: "#eee",

                barBorderRadius: 5
              },

              label: {
                show: true,

                position: "right",

                distance: 10,

                formatter: function (params) {
                  for (var i = 0; i < option3.series[0].data.length; i++) {
                    if (i == params.dataIndex) {
                      return option3.series[0].data[i];
                    }
                  }
                },

                color: "#ff7c44",

                fontSize: 16
              },

              data: new Array(data3.yaxis.length).fill(5)
            }
          ]
        };

        BigEc3.setOption(option3);

        window.onresize = () => {
          BigEc1.resize();

          BigEc2.resize();

          BigEc3.resize();
        };
      },

      //查询服务类型 (标签)

      getLabel (){
        var url = this.urlobj.getQyLabel
        this.$get(url, {
          labelParentType: "service",
          communityIds: this.rule.communityIdList.join(",")
        }).then(res => {
          this.serviceList = res.rows.map(item => {
            return {
              isSelect:false,
              name:item.dicName,
              id:item.id,
              children:item.children.map(_item => {
                return {
                  isSelect:false,
                  name:_item.dicName,
                  id:_item.id,
                  childShow:false,
                  children:[]
                }
              }),
              childShow:true,
            }
          })
          this.serviceList.push({
            isSelect:false,
            name:'全部',
            id:996,
            children:[],
            childShow:true
          })
        })
      },

      //获取行政区域

      getChildShequ() {
        var url = this.urlobj.getDivision("company");

        this.$get(url).then(res => {
          var num = 0
          var ids = []
          var counts = []
          ids = res.rows.map(item => {
            return item.communityId
          })
          var item1 = {
            name: '全部',
            id: ids.join(','),
            isSelect: false
          }
          var list = res.rows.map(item => {
            return {
                name: item.communityName,
                id: item.communityId,
                isSelect: item.communityId == this.$store.state.streetorcommunityid
            };
          })
          list.unshift(item1)
          console.log(list)
          that.childShequ = list
        });
      },

      //显示 隐藏组织区域列表

      showShequList() {
        this.showShequ = !this.showShequ;
      },

      //选择组织区域

      selectShequ(shequ, index) {
        this.childShequ.forEach(item => {
          if (item.id == shequ.id) {
            item.isSelect = true
            var index = String(item.id).indexOf(',')
            var idlist = index == -1 ? [item.id] : item.id.split(',')
            this.rule.communityIdList = idlist
          }
          else item.isSelect = false
        })
        this.rule.serviceIdList = []

        if (markerList) map.remove(markerList)
        that.qiyeTotal = []
        that.changeMaxPage = 1
        markerList = []
        that.page = 1
        this.getLabel()
        this.getQiye()
      },

      //显示 隐藏服务列表

      showServiceList() {
        this.showService = !this.showService;
      },

      //选择服务类型

      selectService(item, index) {
        item.isSelect = !item.isSelect;

        if (index == that.serviceList.length - 1 && !item.isSelect) {
          that.serviceList.forEach(item => {
            if (item.children.length) {
              item.children.forEach(child => {
                child.isSelect = false;
              });
            }

            item.isSelect = false;
          });
        } else if (index == that.serviceList.length - 1 && item.isSelect) {
          that.serviceList.forEach(item => {
            if (item.children.length) {
              item.children.forEach(child => {
                child.isSelect = true;
              });
            }

            item.isSelect = true;
          });
        }

        if (
          that.serviceList[index].children.length > 0 &&
          item.children.length == 0 &&
          !item.isSelect
        ) {
          that.serviceList[index].isSelect = false;
        }

        if (
          that.serviceList[index].children.length > 0 &&
          item.children.length == 0 &&
          item.isSelect
        ) {
          that.serviceList[index].isSelect = true;

          that.serviceList[index].children.forEach(res => {
            if (!res.isSelect) {
              that.serviceList[index].isSelect = false;

              return;
            }
          });
        }

        if (item.children.length > 0) {
          if (item.isSelect) {
            item.childShow = true;

            item.children.forEach(data => {
              data.isSelect = true;
            });
          } else {
            item.children.forEach(data => {
              data.isSelect = false;
            });
          }
        }

        serviceId = [];

        that.serviceList.forEach(item => {
          if (item.children.length > 0) {
            item.children.forEach(child_item => {
              if (child_item.isSelect) {
                serviceId.push(child_item.id);
              }
            });
          } else {
            if (item.isSelect) {
              serviceId.push(item.id);
            }
          }
        });

        if (markerList) map.remove(markerList);

        that.qiyeTotal = [];

        markerList = [];

        that.page = 1;

        if (!serviceId.length && !communityId.length) return;

        that.rule.serviceIdList = serviceId;

        that.getQiye();
      },

      getQiye() {
        let url = this.urlobj.getQyList;

        var reg = /[0-9]+.[0-9]+/g;

        this.$post(url, {
          pageNum: this.page,
          pageSize: 999,
          ...that.rule
        }).then(res => {
          var qiyeTotal = that.qiyeTotal;
          var data = res.rows.filter(item => {
            return item.coordinate;
          });
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              var zuobiao = "";

              if (data[i].coordinate && data[i].coordinate != '' && data[i].coordinate != '{}') {
                var xy = data[i].coordinate.match(reg);
                console.log(xy)
                if(xy) zuobiao = xy.join(",");
              }
              
                qiyeTotal.push({
                  name: data[i].companyName,

                  adress: data[i].address,

                  pic: data[i].headPicUrl == null ? "" : res.rows[i].headPicUrl,

                  zuobiao,

                  dian: data[i].companyServiceList && data[i].companyServiceList[0].dropPicUrl?data[i].companyServiceList[0].dropPicUrl:'//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
                });
              
            }
            that.qiyeTotal = qiyeTotal;
            that.qiyeList = that.qiyeTotal.slice(0, that.rows);
            console.log(this.qiyeList)
            that.setMarkers(qiyeTotal);
          }
        });
      },

      setMarkers(list) {
        list.forEach((item, index) => {
          if (item.zuobiao) {
            var icon = new AMap.Icon({
              size: new AMap.Size(30, 40), // 图标尺寸

              image: item.dian,

              // imageOffset: new AMap.Pixel(0, -10),  // 图像相对展示区域的偏移量，适于雪碧图等

              imageSize: new AMap.Size(22, 30) // 根据所设置的大小拉伸或压缩图片
            });

            var marker = new AMap.Marker({
              position: new AMap.LngLat(
                item.zuobiao.split(",")[0],
                item.zuobiao.split(",")[1]
              ), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]

              title: item.name,

              icon: icon
            });

            // 自定义点标记内容

            //             var markerContent = document.createElement("div");

            //

            //             // 点标记中的图标

            //             var markerImg = document.createElement("img");

            //             markerImg.className = "markerlnglat";

            //             markerImg.src = "//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png";

            //             markerImg.setAttribute("style","width:30px;height:40px")

            //             markerContent.appendChild(markerImg);

            //

            //             // 点标记中的文本

            //             var markerSpan = document.createElement("span");

            //             markerSpan.className = 'marker';

            //             markerSpan.innerHTML = index+1;

            //             markerContent.appendChild(markerSpan);

            //             markerSpan.setAttribute("style","color:#fff;font-size:19px;position:absolute;top:0px;width: 30px;display:flex;justify-content:center;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;");

            //             marker.setContent(markerContent); //更新点标记内容

            markerList.push(marker);
          }
        });

        if (markerList.length > 0) {
          map.add(markerList);

          map.setCenter(markerList[0].getPosition());
        }
      },

      showChild(data) {
        if (data.children.length > 0) {
          data.childShow = !data.childShow;
        } else {
          return;
        }
      },

      getHeatmap() {
        var url = this.urlobj.getHeatmap;

        this.$get(url).then(res => {
          var heatMap = res.rows.map(item => {
            return {
              lng: item.longitude,

              lat: item.latitude,

              count: item.count
            };
          });

          // map.setCenter(new AMap.LngLat(heatMap[0].lng,heatMap[0].lat))

          map.plugin(["AMap.Heatmap"], function () {
            //加载热力图插件

            heatmap = new AMap.Heatmap(map, {
              radius: 25, //给定半径

              opacity: [0, 0.8]
            }); //在地图对象叠加热力图

            heatmap.setDataSet({data: heatMap, max: 100}); //设置热力图数据集

            //具体参数见接口文档
          });

          that.heatMap = heatMap;
        });
      }
    },

    mounted() {
      that = this;

      window.addEventListener("resize", this.handleResize);

      this.Height = window.document.body.offsetHeight - 60;

      this.Width = window.document.body.offsetWidth;

      this.getEchartsData();

      // this.getLabel()

      this.getChildShequ();

      this.initMap();
      this.getLabel();
      this.getHeatmap();
      this.getQiye();

    },

    beforeDestroy: function () {
      window.removeEventListener("resize", this.handleResize);
    },

    destroyed() {
      map.destroy();
    }
  };
</script>

<style scoped>
  .qy-header-wrapper {
    display: flex;

    /*height: 30px;*/

    line-height: 30px;

    padding-top: 30px;

    justify-content: center;

    position: relative;

    margin-bottom: 30px;
  }

  .qy-header {
    font-size: 25px;

    text-align: center;
  }

  .tab {
    position: absolute;

    left: 20px;

    background: #fff;

    color: #a0a0a0;

    border-radius: 5px;

    font-size: 14px;
  }

  .tab1 {
    border-bottom-left-radius: 5px;

    border-top-left-radius: 5px;
  }

  .tab2 {
    border-right: 1px solid #eee;

    border-left: 1px solid #eee;
  }

  .tab3 {
    border-bottom-right-radius: 5px;

    border-top-right-radius: 5px;
  }

  .tab-item {
    /* width: 50px; */

    text-align: center;

    height: 35px;

    line-height: 35px;

    cursor: default;

    padding: 0 15px;
  }

  .select {
    background: #ff7b44;

    color: #fff;
  }

  .map-wrapper {
    margin: 0 auto;

    width: 97.7%;

    background: #fff;

    height: 910px;
  }

  .btn-wrapper {
    position: absolute;

    right: 40px;

    top: 20px;

    background: #fff;

    color: #a0a0a0;

    border-radius: 5px;

    z-index: 100;

    box-shadow: 0px 3px 10px 0px #9f9e9a;
  }

  .select-btn {
    width: 100px;

    height: 30px;

    line-height: 30px;

    text-align: center;
  }

  .select-service-btn {
    border-right: 1px solid #f2f2f2;

    width: 155px;
  }

  .service-list {
    background: #fff;

    border-radius: 5px;

    margin-top: 5px;

    color: #333;

    padding-left: 10px;

    box-shadow: 0px 3px 10px 0px #9f9e9a;
  }


  .service-li {
    flex-wrap: wrap;
  }

  .service-name {
    width: 80%;
    text-align: left;
  }

  .service-child {
    padding-left: 30px;
  }


  .xuan {
    color: #ff7b44;

    font-size: 12px;

    margin-right: 10px;
  }

  .weixuan {
    color: #ddd;

    font-size: 12px;

    margin-right: 10px;
  }

  .echart-wrapper {
    border-radius: 5px;

    background: #fff;

    position: absolute;

    top: 20px;

    left: 30px;

    box-shadow: 2px 2px 5px 1px #ddd;
  }

  .echart1-wrapper {
    top: 20px;

    left: 30px;
  }

  .bigEchart-wrapper {
    top: 20px;

    left: 360px;

    z-index: 101;
  }

  .echart2-wrapper {
    top: 315px;

    left: 30px;
  }

  .echart3-wrapper {
    top: 610px;

    left: 30px;

    z-index: 160;
  }

  #echart1 {
    width: 300px;

    height: 240px;

    padding: 0 10px;
  }

  #bigEchart1 {
    /*height: 685px;*/

    /*width: 1190px;*/

    padding: 10px;
  }

  #echart2 {
    width: 300px;

    height: 240px;

    padding: 0 10px;
  }

  #bigEchart2 {
    /*height: 685px;*/

    /*width: 1190px;*/

    padding: 10px;
  }

  #echart3 {
    width: 300px;

    height: 240px;
  }

  #bigEchart3 {
    /*height: 685px;*/

    /*width: 1190px;*/

    padding: 10px;
  }

  .echart-head {
    height: 40px;

    align-items: center;

    font-size: 14px;

    border-bottom: 1px solid #f4f3ef;

    justify-content: space-between;

    padding: 0 10px;
  }

  .echart-head-icon {
    color: #ff7b44;

    margin-right: 10px;
  }

  .input-card {
    width: 32rem;

    z-index: 170;
  }

  .input-card .btn {
    margin-right: 0.8rem;
  }

  .input-card .btn:last-child {
    margin-right: 0;
  }

  .select-btn-text {
    justify-content: center;
  }

  .xia {
    margin-left: 10px;
  }

  .changexia {
    transform: rotate(180deg);
  }

  .box_center {
    align-items: center;
  }

</style>
